import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionSituacionActividadByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionSituacionActividadByUser = () => {
  const [loadingGetDeclaracionSituacionActividadByUser, setLoadingGetDeclaracionSituacionActividadByUser] = useState(false);
  const [successGetDeclaracionSituacionActividadByUser, setSuccessGetDeclaracionSituacionActividadByUser] = useState(false);
  const [errorGetDeclaracionSituacionActividadByUser, setErrorGetDeclaracionSituacionActividadByUser] = useState<any>(null);
  const [dataGetDeclaracionSituacionActividadByUser, setDataDeclaracionSituacionActividadByUser] = useState<any>(null);

  const [statusGetDeclaracionSituacionActividadByUser, setStatusGetDeclaracionSituacionActividadByUser] =
    useState<StatusGetDeclaracionSituacionActividadByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getDeclaracionSituacionActividadByUser = async (
    userId: string,
    expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionSituacionActividadByUser(true);
    setSuccessGetDeclaracionSituacionActividadByUser(false);
    setErrorGetDeclaracionSituacionActividadByUser(null);

    try {
      const res = await apirecord.getDeclaracionSituacionActividadItByUser(userId, expedienteId);

      setStatusGetDeclaracionSituacionActividadByUser({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetDeclaracionSituacionActividadByUser(true);
      setDataDeclaracionSituacionActividadByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetDeclaracionSituacionActividadByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetDeclaracionSituacionActividadByUser(err);
      console.error("Error en getDeclaracionSituacionActividadByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionSituacionActividadByUser(false);
    }
  };

  return {
    getDeclaracionSituacionActividadByUser,
    loadingGetDeclaracionSituacionActividadByUser,
    successGetDeclaracionSituacionActividadByUser,
    errorGetDeclaracionSituacionActividadByUser,
    dataGetDeclaracionSituacionActividadByUser,
    statusGetDeclaracionSituacionActividadByUser
  };
};

export default useGetDeclaracionSituacionActividadByUser;
